<template>

       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                  
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'الحلقات'" :to="{name: 'lessons'}"> الحلقات</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'lessons.edit', params: {id: $route.params.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                               <i class="flaticon-computer-4"></i> 
                                            بيانات الحلقة</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="update()">
                                        <div class="row">
                                         <div class="col-md-12">
                                              <label for="exampleFormControlInput12">الاسم</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.ar.name" placeholder=" الاسم ">
                                        <div class="invalid-feedback" :style="getErrors['ar.name'] ? 'display: block' : 'display: none;'"   v-if="getErrors['ar.name']">
                                              {{ getErrors['ar.name'][0] }}
                                        </div>
                                    </div>
                                     </div>

                                        <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة</label>
                                            <treeselect :options="data.stages" :auto-load-root-options="true" @select="getGroups" v-model="data.form.stage_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصفوف</label>
                                            <treeselect :options="data.groups" :auto-load-root-options="true"  v-model="data.form.group_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                     <div class="col-md-6">
                                    <div class="form-group mb-4">
                                        <label for="exampleFormControlInput1">الحالة</label>
                                         <div class="row">
                                        <div class="custom-control col-md-6 custom-radio mb-3">
                                          <label class="new-control new-radio radio-primary" for="customRadio1">
                                          <input type="radio" id="customRadio1" name="customRadio" 
                                          v-model="data.form.status" value="1" class="new-control-input">
                                         <span class="new-control-indicator"></span>
                                         نشط
                                         </label>
                                      </div>
                                      <div class="custom-control col-md-6 custom-radio mb-4">
                                          <label class="new-control new-radio radio-danger" for="customRadio2">
                                          <input type="radio" id="customRadio2" name="customRadio"
                                           v-model="data.form.status" value="0" class="new-control-input">
                                           <span class="new-control-indicator"></span>
                                              غير نشط
                                              </label>
                                      </div>
                                      <div class="invalid-feedback" :style="getErrors['status'] ? 'display: block' : 'display: none;'"   v-if="getErrors['status']">
                                              {{ getErrors['status'][0] }}
                                        </div>
                                        </div>
                                    </div>
                                     </div>
                                      </div>
                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'lessons'}">
                                      <span>رجوع</span>
                                    </router-link>
                              </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      data: {
        title: this.$root.trans['admins.edit'],
        subTitle: this.$root.trans['admins.edit.word'],
        checker: false,
        form:{
            ar: {name: '', address: ''},
            stage_id: '',
            group_id: '',
            image: '',
        },
        roles: {
        },
        options: [],
        stages: [],
        groups: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
      this.getRequirements();
  },
  methods: {
    uploadFile() {
        this.data.form.image = this.$refs.file.files[0];
      },
      resetForm(){
        this.data.form = {
          ar: {name: ''},
           stage_id: '',
            group_id: '',
          status: 1
        };
      },
      getStages(){
        this.$baseApi.get('/lessons/' + this.$route.params.id + '/edit?option=stage').then((response)=>{
            if(response.data.code == 200){
               this.data.stages = response.data.data.options;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getGroups(val){
        this.data.form.group_id = '';
        this.$baseApi.get('/lessons/' + this.$route.params.id + '/edit?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.data.groups = response.data.data.options;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getGroupsById(id){
        this.$baseApi.get('/lessons/' + this.$route.params.id + '/edit?option=group&i='+id).then((response)=>{
            if(response.data.code == 200){
               this.data.groups = response.data.data.options;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getInfo(){
        this.$baseApi.get('/lessons/' + this.$route.params.id + '/edit').then((response)=>{
            if(response.data.code == 200 && response.data.data != null){
                this.data.form = this.dataHanlde(response.data.data.lesson);
                this.getGroupsById(this.data.form.stage_id);
            
            }else if(response.data.code == 404){
                router.push('/lessons');
            }else{
                alert(response.data.data.error);
                router.push('/lessons');
            }
        });
      },
      update(){
          this.data.isRequested = true;

        this.$baseApi.patch('/lessons/' + this.$route.params.id, this.data.form).then((response)=>{
            if(response.data.code === 200){
              localStorage.setItem('flash_message', 'تمت عملية التعديل');
                router.push('/lessons');
            }
        }).catch((error) => {
          this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
          this.data.isRequested = false
        })
      },
      getRequirements(){
        this.getStages();
        this.getInfo();
      },
      getRoles(flag = false){
        if(flag){
          this.data.form.role_id = '';
        }
        
        this.$baseApi.get('/roles?pluck=1&role=' + this.data.form.role).then((response)=>{
            if(response.data.code == 200){
               this.data.roles = response.data.data;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      selected(node, instanceId){
        this.form.location_id = node.id;
      },
      dataHanlde(data){
        return {
          ar: {name: data.name},
          stage_id: data.stage_id,
          group_id: data.group_id,
          status: data.status == true ? 1 : 0
        }
      },

      uploadImage(e){
                const image = e.target.files[0];
                console.log(image);
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                  this.data.form.image = e.target.result;  
                };
      },
      getTree(){
        this.$baseApi.get('/locations?tree=true' ).then((response)=>{
            if(response.data.code == 200){
              this.data.options = response.data.data;
            }else if(response.data.code == 401){
                this.error = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
  }
};
</script>
<style>
</style>
